import axios from 'axios'
import { getCookie, removeCookie, setHoursCookie } from './auth'

const service = axios.create(
  {
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api/' : window.location.origin + '/api/',
    timeout: process.env.NODE_ENV === 'development' ? 0 : 15000,
    withCredentials: true
  })

service.interceptors.request.use(
  async config => {
    config.headers.post['Content-Type'] = 'application/json multipart/form-data'
    config.headers.common.Authorization = 'Bearer ' + getCookie('token')
    if ((config.url.indexOf('excel') !== -1) && process.env.NODE_ENV !== 'development') {
      config.timeout = 100000
    }
    if (config.url.indexOf('sinif-sorumlu') !== -1) {
      config.timeout = 30000
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.config.url.indexOf('excel') !== -1) {
      return Promise.resolve(response)
    } else {
      const verssion = getCookie('frontend-version')
      if (!verssion) {
        setHoursCookie('frontend-version', response.data.version, 8760)
        location.reload()
      }
      if (response.data.version !== verssion) {
        setHoursCookie('frontend-version', response.data.version, 8760)
        location.reload()
      }
      return Promise.resolve(response.data)
    }
  },
  async error => {
    // console.log(error.config)
    if (error.response) {
      const { status: statusKod } = error.response
      if (statusKod === 401) {
        Sil()
        location.reload()
      } else if (statusKod === 400) {
        if (error.response && error.response.data && error.response.data.message) {
          window.lokum.$bvToast.toast(error.response.data.message, {
            title: 'Hata',
            autoHideDelay: 5000,
            variant: 'danger',
            solid: true
          })
        }
      } else if (statusKod === 403) {
        if (error.response && error.response.data && error.response.data.message) {
          window.lokum.$bvToast.toast(error.response.data.message, {
            title: 'Hata',
            autoHideDelay: 5000,
            variant: 'danger',
            solid: true
          })
          window.lokum.$router.push('/anasayfa')
        }
      } else if (statusKod >= 500) {
        window.lokum.$bvToast.toast('Sunucu Hatası Oluştu', {
          title: 'Hata',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true
        })
      } else {
        window.lokum.$bvToast.toast('Bilinmeyen Bir Hata Oluştu', {
          title: 'Hata',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true
        })
      }
    } else {
      window.lokum.$bvToast.toast('İletişim Hatası Oluştu', {
        title: 'Hata',
        autoHideDelay: 5000,
        variant: 'danger',
        solid: true
      })
    }
    return Promise.reject(error.response)
  }
)

function Sil () {
  removeCookie('token')
}

export default service
